import * as React from "react";
import { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Settings from "@material-ui/icons/Settings";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import ExitToApp from "@material-ui/icons/ExitToApp";
import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { observer } from "mobx-react-lite";
import { Routes } from "../../../../routes/routes";
import { authStore } from "../../../../mobx/stores/AuthStore/AuthStore";

export const HeaderMenu = observer(() => {
  const history = useHistory();
  const { authenticatedUser, logout } = authStore;
  const id = Object.keys(authenticatedUser)[0];
  const [profileAnchor, setProfileAnchor] = useState(null);

  const handleOpen = useCallback(
    (e) => {
      setProfileAnchor(e.currentTarget);
    },
    [setProfileAnchor]
  );

  const handleClose = useCallback(() => {
    setProfileAnchor(null);
  }, [setProfileAnchor]);

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <AccountCircle />
      </IconButton>
      {renderMenu()}
    </>
  );

  function renderMenu() {
    return (
      <Menu
        anchorEl={profileAnchor}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        keepMounted
        open={Boolean(profileAnchor)}
        onClose={handleClose}
      >
        <MenuItem onClick={onSettings} disabled={!id}>
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText>Настройки</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText>Выйти</ListItemText>
        </MenuItem>
      </Menu>
    );
  }

  function onSettings() {
    handleClose();
    history.push(`/${Routes.user}/${id}`);
  }

  function onLogout() {
    handleClose();
    logout();
  }
});
